import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'admin-env-label',
  templateUrl: './admin-env-label.component.html',
  styleUrls: ['./admin-env-label.component.scss']
})
export class AdminEnvLabelComponent implements OnInit {
  /// <summary>
  // ADMIN LABEL component for displaying the environment label
  /// </summary>

  envName: string;

  ngOnInit(): void {
    this.envName = environment.system.name;
  }

  get ShowEnvLabel(): boolean {
    if (this.envName == 'prod') {
      return false;
    }
    return true;
  }

  get EnvironmentName(): string {
    switch (this.envName) {
      case 'local': return 'Localhost';
      case 'dev': return 'Development';
      case 'test': return 'Test';
      case 'prod': return 'Production';
      default: return '## error fetching env name ##';
    }
  }

  getBackgroundColor(): string {
    switch (this.envName) {
      case 'local': return 'black';
      case 'dev': return '#5eac24';
      case 'test': return '#ffb000';
      case 'prod': return '#006df0';

      default: return 'transparent';
    }
  }

  getTextColor(): string {
    const colorMap: Record<string, string> = {
      local: '#FFF',
      dev: '#FFF',
      test: '#000',
      prod: '#FFF'
    };

    return colorMap[this.envName] || '#000';
  }


}
